module.exports = __webpack_public_path__ + "img/table.ae512132.svg";